let STYLE = {};

STYLE.FONT = {
  SIZE: 13,
  FAMILY: "Noto Sans",
};

STYLE.COLOR = {
  LIGHT: "#888",
  LIGHTER: "#ccc",
  LIGHTEST: "#eee",

  SL_FLAG: {
    MAROON: "#8D153A",
    ORANGE: "#EB7400",
    GREEN: "#00534E",
    YELLOW: "#FFBE29",
    BLACK: "#000",
  },
};

export default STYLE;
